export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5416.3dc2cb36.jpg";